import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { alert_error, alert_success } from "../../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { update_input_url_orders } from '../../../../order/orders/actions.js';
import Orders from "../../../../order/orders/orders.jsx";
import { Cookies } from '../../../../index.js';

const Account_home = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const set_input_url_orders = (value) => {
        dispatch(update_input_url_orders(value));
    };

    const api_response = useSelector(state => state.api_response);

    function switch_router(link) {
        navigate(link);
    };
    useEffect(() => {
        reset_profile();
    }, []);

    useEffect(() => {
        if (api_response && typeof api_response === "object" && "order" in api_response) {
            reset_profile();
        }
    }, [api_response]);


    function reset_profile() {
        const apiKey = Cookies.get('apikey');
        axios
            .post('https://hust.media/api/orders/account/sellers/api/get_info.php', {
                apikey: apiKey
            })
            .then((response) => {
                const { accounts_api_url } = response.data;
                set_input_url_orders({ accounts_api_url });
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Orders category_main='accounts_shop_api_edit' />
        </>
    );
};

export default Account_home;
